module.exports = __webpack_public_path__ + "static/media/icon-chicken-blue.54fb9ed9.jpg";